module.exports = "/images/trigger-close.svg?c0285ed4a42389a591e4acf9839f6189";